import * as v from 'valibot';
import { integerInRange, dateStringSchema } from '../util/valibot';
export const hastaTransmitterSchema = v.object({
    id: integerInRange(0, 0xffffffff),
    title: v.string(),
    comment: v.string(),
    code: integerInRange(0, 0x3ffffff),
    unit: integerInRange(0, 15),
    created: dateStringSchema,
});
